<template>
  <div class="loading-overlay">
    <BlockUI :blocked="isLoading" full-screen />
    <ProgressSpinner v-show="isLoading" class="overlay" stroke-width="4" />
  </div>
</template>

<script lang="ts">
import BlockUI from 'primevue/blockui'
import ProgressSpinner from 'primevue/progressspinner'

export default {
  name: 'LoadingOverlay',

  components: {
    BlockUI,
    ProgressSpinner
  },

  props: {
    isLoading: Boolean
  }
}
</script>

<script setup lang="ts"></script>

<style lang="scss">
.overlay {
  position: fixed !important;
  top: 45%;
  left: 50%;
  z-index: 1200; /* this seems to work for me but may need to be higher*/
}
</style>
